export default __webpack_public_path__ + "static/media/MemSQL_horizontal_lockup_blue_logo.990219d0.png";